import styles from './PageContainer.module.scss'

export const presets = {
  primary: styles.container,
  grey: styles.grey
}
